export default "__VITE_ASSET__CVlN5N$$__"